const buttonPc = require("../../art/pc/button.art");
const buttonWap = require("../../art/wap/button.art");
const carouselPc = require("../../art/pc/carousel.art");
const carouselWap = require("../../art/wap/carousel.art");
const footerlPc = require("../../art/pc/footer.art");
const footerWap = require("../../art/wap/footer.art");
const mImagePc = require("../../art/pc/mImage.art");
const mImageWap = require("../../art/wap/mImage.art");
const mImageTextPc = require("../../art/pc/mImageText.art");
const mImageTextWap = require("../../art/wap/mImageText.art");
const meetingListPc = require("../../art/pc/meetingList.art");
const meetingListWap = require("../../art/wap/meetingList.art");
const videoPc = require("../../art/pc/video.art");
const videoWap = require("../../art/wap/video.art");
const navPc = require("../../art/pc/nav.art");
const navWap = require("../../art/wap/nav.art");
const simagePc = require("../../art/pc/simage.art");
const simageWap = require("../../art/wap/simage.art");
const sImageTextPc = require("../../art/pc/sImageText.art");
const sImageTextWap = require("../../art/wap/sImageText.art");
const customFormPc = require("../../art/pc/customform.art");
const customFormWap = require("../../art/wap/customform.art");
const richtextPc = require("../../art/pc/customcontent.art");
const richtextWap = require("../../art/wap/customcontent.art");
const file = require("../../art/form/file.art");
const img = require("../../art/form/img.art");
const text = require("../../art/form/text.art");
const radio = require("../../art/form/radio.art");
const checkbox = require("../../art/form/checkbox.art");
const select = require("../../art/form/select.art");
const checkboxSelect = require("../../art/form/checkbox-select.art");
const textarea = require("../../art/form/textarea.art");
const time = require("../../art/form/time.art");
const pagination = require("../../art/common/pagination.art");
const articleDetailPc = require("../../art/pc/articleDetail.art");
const articleDetailWap = require("../../art/wap/articleDetail.art");
const articleDetailBannerPc = require("../../art/pc/articleDetailBanner.art");
const articleDetailBannerWap = require("../../art/wap/articleDetailBanner.art");
const field = require("../../art/form/field.art");
const filePc = require("../../art/pc/file.art");
const fileWap = require("../../art/wap/file.art");
const loginPc = require("../../art/pc/registration.art");
const loginWap = require("../../art/wap/registration.art");
const sidebarPc = require("../../art/pc/sidebar.art");
const sidebarWap = require("../../art/wap/sidebar.art");
const nullPc = require("../../art/pc/null.art");
const nullWap = require("../../art/wap/null.art");
const tabWap = require("../../art/wap/tab.art");
const tabPc = require("../../art/pc/tab.art");
const fileDetailWap = require("../../art/wap/fileDetail.art");
const fileDetailPc = require("../../art/pc/fileDetail.art");
const searchWap = require("../../art/wap/search.art");
const searchDETAILWap = require("../../art/wap/searchDetail.art");
const searchPc = require("../../art/pc/search.art");
const searchDETAILPc = require("../../art/pc/searchDetail.art");

export const arts = {
  BUTTON: {
    pc: buttonPc,
    wap: buttonWap,
  },
  CAROUSEL: {
    pc: carouselPc,
    wap: carouselWap,
  },
  FOOTER: {
    pc: footerlPc,
    wap: footerWap,
  },
  MIMAGE: {
    pc: mImagePc,
    wap: mImageWap,
  },
  MIMAGETEXT: {
    pc: mImageTextPc,
    wap: mImageTextWap,
  },
  MEETING: {
    pc: meetingListPc,
    wap: meetingListWap,
  },
  VIDEO: {
    pc: videoPc,
    wap: videoWap,
  },
  NAV: {
    pc: navPc,
    wap: navWap,
  },
  SIMAGE: {
    pc: simagePc,
    wap: simageWap,
  },
  SIMAGETEXT: {
    pc: sImageTextPc,
    wap: sImageTextWap,
  },
  CUSTOMFORM: {
    pc: customFormPc,
    wap: customFormWap,
  },
  CUSTOMCONTENT: {
    pc: richtextPc,
    wap: richtextWap,
  },
  FIELDFILE: {
    pc: file,
    wap: file,
  },
  FIELDIMG: {
    pc: img,
    wap: img,
  },
  FIELDTEXT: {
    pc: text,
    wap: text,
  },
  FIELDRADIO: {
    pc: radio,
    wap: radio,
  },
  FIELDCHECKBOX: {
    pc: checkbox,
    wap: checkbox,
  },
  FIELDSELECT: {
    pc: select,
    wap: select,
  },
  FIELDCHECKBOXSELECT: {
    pc: checkboxSelect,
    wap: checkboxSelect,
  },
  FIELDTEXTAREA: {
    pc: textarea,
    wap: textarea,
  },
  FIELDTIME: {
    pc: time,
    wap: time,
  },
  PAGINATION: {
    pc: pagination,
    wap: pagination,
  },
  ARTICLEDETAIL: {
    pc: articleDetailPc,
    wap: articleDetailWap,
  },
  ARTICLEDETAILBANNER: {
    pc: articleDetailBannerPc,
    wap: articleDetailBannerWap,
  },
  FIELD: field,
  FILE: {
    pc: filePc,
    wap: fileWap,
  },
  REGISTRATION: {
    pc: loginPc,
    wap: loginWap,
  },
  SIDEBAR: {
    pc: sidebarPc,
    wap: sidebarWap,
  },
  NULL: {
    pc: nullPc,
    wap: nullWap,
  },
  TAB: {
    pc: tabPc,
    wap: tabWap,
  },
  FILEDETAIL: {
    pc: fileDetailPc,
    wap: fileDetailWap,
  },
  SEARCH: {
    pc: searchPc,
    wap: searchWap,
  },
  SEARCHDETAIL: {
    pc: searchDETAILPc,
    wap: searchDETAILWap,
  },
};
